export default __webpack_public_path__ + "static/char-s-61-jp-66f1fc406848c769581dffa4e40b0631.png";